<template>
    <div class="cont-tit">
        <h2 class="page-title">Directions</h2>
    </div>
    <div class="directions">
        <div class="directions__text">
            <div class="directions__box">
                <h3 class="directions__tit">ADDRESS</h3>
                <p class="directions__desc">
                    143, Gasan digital 2-ro, Geumcheon-gu, <br>
                    (Gasan Urban Work Building 2, Rooms 1211-1214) <br>
                    Seoul, Republic of Korea
                </p>
            </div>
            <div class="directions__box">
                <h3 class="directions__tit">TEL</h3>
                <p class="directions__desc">
                    +82-70-7772-7766
                </p>
            </div>
            <div class="directions__box">
                <h3 class="directions__tit">FAX</h3>
                <p class="directions__desc">
                    +82-70-8224-0874
                </p>
            </div>
            <div class="directions__box">
                <h3 class="directions__tit">EMAIL</h3>
                <p class="directions__desc">
                    castle12@osangtech.co.kr
                </p>
            </div>
            <div class="btn-wrap left mt80">
                <a href="/file/OSE-Commerce_Osang_Technology_Company_Introduction.pdf" download class="btn">Download company profile</a>
            </div>
        </div>

        <div class="directions__map">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3166.1458679150915!2d126.8753099762939!3d37.480884029034186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61ee2f49ade7%3A0x842dd1185f8dd54c!2z6rCA7IKw7Ja067CY7JuM7YGsMg!5e0!3m2!1sen!2skr!4v1727084091056!5m2!1sen!2skr"
                width="732" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            </iframe>
        </div>

    </div>
</template>
<script>
    export default {

    }
</script>